import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import api, { formatApiError } from "@/lib/api";

export default function AdminLogin() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [forgotMsg, setForgotMsg] = useState("");

  const forgot = async () => {
    if (!email) return setError("Enter your email above first, then click Forgot password.");
    setError("");
    try {
      const { data } = await api.post("/auth/forgot-password", { email, origin_url: window.location.origin });
      setForgotMsg(data.message);
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || err.message);
    }
  };

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      navigate("/admin");
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#EAF0EE] flex items-center justify-center px-6">
      <div className="w-full max-w-md">
        <div className="flex items-center justify-center gap-2 mb-8">
          <img src="/brand/logo-mark.png" alt="Hola Movers" className="h-12 w-auto" />
          <span className="font-serif text-2xl text-charcoal-800">Hola Movers</span>
        </div>
        <form onSubmit={submit} data-testid="admin-login-form" className="rounded-3xl bg-white p-8 border border-sand-200 shadow-[0_8px_32px_rgba(44,42,41,0.06)]">
          <h1 className="font-serif text-2xl text-charcoal-800 mb-1">Admin sign in</h1>
          <p className="text-sm text-charcoal-500 mb-6">Manage content, bookings, and settings.</p>
          <label className="text-sm font-medium text-charcoal-600 mb-2 block">Email</label>
          <input
            data-testid="admin-email"
            type="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="w-full bg-white border border-sand-200 rounded-lg px-4 py-3 mb-4 focus:outline-none focus:ring-2 focus:ring-sage/50"
          />
          <label className="text-sm font-medium text-charcoal-600 mb-2 block">Password</label>
          <input
            data-testid="admin-password"
            type="password"
            required
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="w-full bg-white border border-sand-200 rounded-lg px-4 py-3 mb-6 focus:outline-none focus:ring-2 focus:ring-sage/50"
          />
          {error && <p data-testid="admin-login-error" className="text-sm text-destructive mb-4">{error}</p>}
          {forgotMsg && <p data-testid="admin-forgot-sent" className="text-sm text-sage-700 mb-4">{forgotMsg}</p>}
          <button
            data-testid="admin-login-submit"
            disabled={loading}
            className="w-full rounded-full bg-terracotta py-3 text-white font-medium hover:bg-terracotta-hover transition-colors disabled:opacity-60"
          >
            {loading ? "Signing in…" : "Sign in"}
          </button>
          <button type="button" data-testid="admin-forgot-link" onClick={forgot}
            className="mt-4 w-full text-center text-sm text-charcoal-500 hover:underline">
            Forgot password?
          </button>
        </form>
      </div>
    </div>
  );
}
